<template>
	<v-layout v-if="!dataSame">
		<v-flex xs6>
			<old-version-marker/>
			<priority-tree
				v-if="contestId"
				:contest-id="contestId"
				v-model="old"
				:readonly="true"
			></priority-tree>
		</v-flex>
		<v-flex xs6>
			<new-version-marker/>
			<priority-tree
				v-if="contestId"
				:contest-id="contestId"
				v-model="current"
				:readonly="true"
			></priority-tree>
		</v-flex>
	</v-layout>
</template>

<script>
	import PriorityTree from "../components/PriorityTree";
	import OldVersionMarker from "./oldVersionMarker";
	import NewVersionMarker from "./NewVersionMarker";

	export default {
		name: "ComparePriorityTree",
		components: {NewVersionMarker, OldVersionMarker, PriorityTree},

		computed: {
			dataSame () {
				let comparisonResult = JSON.stringify(this.old) === JSON.stringify(this.current);
				if (comparisonResult === false) {
					this.$emit('dataDiffer', true);
				}
				return comparisonResult;
			}
		},

		props: {
			contestId: {},
			old: {},
			current: {}
		}
	};
</script>

<style scoped>

</style>
